import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import { FIX_LOCATION } from 'app/constants/hint';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingLowPriceContractForm({ updateLocation, users, approver }) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'contract_ids',
          role: 'abnormal_contract',
          range: 'group',
          title: '异常合同审批人',
          hint: FIX_LOCATION.contract,
          selectedUsers: approver
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  return {
    users: selectors.getSpaceUsers(state),
    approver:
      selectors.getTeamRolesOfLocation(state, loc_id, 'abnormal_contract') || []
  };
}

export default connect(mapStateToProps)(LocationSettingLowPriceContractForm);
